import { FC, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { format, isAfter } from 'date-fns';
import { useStyles } from '@sweatpals/react-ui-kit';
import { priceFormatter, UserToMembershipDto, getShortPeriodFromFrequency } from '@sweatpals/shared';
import { membershipFormStyles } from './membership-form.styles';

export interface MembershipInfoTableProps {
	userMembership: UserToMembershipDto;
}

export const MembershipInfoTable: FC<MembershipInfoTableProps> = (props) => {
	const { userMembership } = props;

	const membershipBillingDate = useMemo(() => new Date(userMembership.actualTo), []);
	const isMembershipActive = useMemo(() => isAfter(membershipBillingDate, new Date()), [membershipBillingDate]);

	const styles = useStyles(membershipFormStyles);

	return (
		// <Box sx={styles.membershipInfoBody}>
		// 	<Box sx={styles.membseshipInfoRow}>
		// 		<Box sx={styles.membershipInfoRowName}>Membership Plan</Box>
		// 		<Box sx={styles.membershipInfoValue()}>
		// 			<Typography>{userMembership.membership.name}</Typography>

		// 			<Box sx={styles.membershipInfoPriceRow}>
		// 				<Typography sx={styles.membershipInfoPrice}>
		// 					{priceFormatter(userMembership.membershipTier?.amount)}
		// 				</Typography>
		// 				<Box sx={styles.membershipPriceSeparator}>{' • '}</Box>
		// 				<Typography sx={styles.membershipRate}>
		// 					{getShortPeriodFromFrequency(userMembership.membershipTier?.frequency)}
		// 				</Typography>
		// 			</Box>
		// 		</Box>
		// 	</Box>

		// 	<Box sx={styles.membseshipInfoRow}>
		// 		<Box sx={styles.membershipInfoRowName}>Status</Box>
		// 		<Box sx={styles.membershipInfoValue(isMembershipActive)}>{isMembershipActive ? 'Active' : 'Inactive'}</Box>
		// 	</Box>
		// 	<Box sx={styles.membseshipInfoRow}>
		// 		<Box sx={styles.membershipInfoRowName}>Next billing date</Box>
		// 		<Box sx={styles.membershipInfoValue()}>{format(membershipBillingDate, 'MMM do, yyyy')}</Box>
		// 	</Box>
		// </Box>
		<></>
	);
};
